export default __webpack_public_path__ + "static/cv-c7b84ed594b6ec82e8e2745d701e056e.pdf";